import React from "react";
import { Box, Collapse, Select, MenuItem, InputBase, Typography, Button } from "@mui/material";
import {
  selectSx,
  menuProps,
  noteMultilineSx,
  ghostButtonSx,
  primaryButtonSx,
} from "bundles/Internal/components/common/FloatingTimer";

export default function PausedPanel({ open, stoppedEntry, setStoppedEntry, coloredProjects, onCancel, onConfirm }) {
  const proj = coloredProjects.find((cp) => cp.id === stoppedEntry?.projectId);

  return (
    <Collapse in={open} unmountOnExit>
      <Box sx={{ px: 2.5, pb: 2, display: "flex", flexDirection: "column", gap: 1.25 }}>
        {/* Project */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Select
            value={stoppedEntry?.projectId || ""}
            onChange={(e) => setStoppedEntry((st) => (st ? { ...st, projectId: e.target.value, taskId: "" } : st))}
            displayEmpty
            size="small"
            variant="outlined"
            MenuProps={menuProps}
            sx={{ ...selectSx, flex: 1, minWidth: 0 }}
            renderValue={(value) => {
              if (!value) {
                return (
                  <Typography sx={{ color: "hsl(150 10% 46%)", fontSize: 14, fontFamily: "Segoe UI Regular, sans-serif, system-ui" }}>Select project</Typography>
                );
              }
              const p = coloredProjects.find((cp) => cp.id === value);
              if (!p) return null;
              return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: p.color, flexShrink: 0 }} />
                  <Typography sx={{ fontSize: 14, fontFamily: "Segoe UI Regular, sans-serif, system-ui", color: "hsl(150 30% 12%)" }}>
                    {p.name}{p.company?.name ? ` — ${p.company.name}` : ""}
                  </Typography>
                </Box>
              );
            }}
          >
            {coloredProjects.map((p) => (
              <MenuItem key={p.id} value={p.id}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: p.color, flexShrink: 0 }} />
                  <Typography sx={{ fontSize: 14, fontFamily: "Segoe UI Regular, sans-serif, system-ui", color: "hsl(150 30% 12%)" }}>
                    {p.name}{p.company?.name ? ` — ${p.company.name}` : ""}
                  </Typography>
                </Box>
              </MenuItem>
            ))}
          </Select>
        </Box>

        {/* Task */}
        <Select
          value={stoppedEntry?.taskId || ""}
          onChange={(e) => setStoppedEntry((st) => (st ? { ...st, taskId: e.target.value } : st))}
          displayEmpty
          size="small"
          variant="outlined"
          MenuProps={menuProps}
          sx={selectSx}
        >
          <MenuItem value="">
            <Typography sx={{ color: "hsl(150 10% 46%)", fontSize: 14, fontFamily: "Segoe UI Regular, sans-serif, system-ui" }}>No task</Typography>
          </MenuItem>
          {(proj?.tasks || []).map((t) => (
            <MenuItem key={t.id} value={t.id}>
              <Typography sx={{ fontSize: 14, fontFamily: "Segoe UI Regular, sans-serif, system-ui", color: "hsl(150 30% 12%)" }}>{t.name.replace(/_/g, " ")}</Typography>
            </MenuItem>
          ))}
        </Select>

        {/* Note */}
        <InputBase
          value={stoppedEntry?.note || ""}
          onChange={(e) => setStoppedEntry((st) => (st ? { ...st, note: e.target.value } : st))}
          placeholder="Add a note (optional)"
          multiline
          minRows={3}
          maxRows={3}
          sx={noteMultilineSx}
        />

        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            onClick={onCancel}
            sx={{
              ...ghostButtonSx,
              flex: 1,
              color: "hsl(0, 70%, 45%)",
              "&:hover": { backgroundColor: "hsla(0, 70%, 45%, 0.08)" },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            disableElevation
            disabled={!stoppedEntry?.projectId}
            sx={{ ...primaryButtonSx, flex: 1 }}
          >
            Confirm
          </Button>
        </Box>
      </Box>
    </Collapse>
  );
}
